(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-marketplace-multiple-shares/assets/marketplace-multiple-shares.js') >= 0) return;  svs.modules.push('/components/payment/middleware-marketplace-multiple-shares/assets/marketplace-multiple-shares.js');

'use strict';

const MiddlewarePaymentError = svs.components.payment.common.error.MiddlewarePaymentError;
const InteractionContext = svs.components.payment.common.context.InteractionContext;
const logger = svs.components.payment.common.logger;
const jupiterFetch = svs.core.jupiterFetch;
const getAvailableShares = async _ref => {
  let activatedDrawId = _ref.activatedDrawId,
    containerId = _ref.containerId,
    groupId = _ref.groupId;
  const response = await jupiterFetch.fetch("marketplace/1/groups/".concat(groupId, "/activateddraw?containerId=").concat(containerId, "&activatedDrawId=").concat(activatedDrawId), {
    method: 'GET',
    headers: {
      accept: 'application/json'
    }
  });
  const data = await response.json();
  const containerWithDraw = (data === null || data === void 0 ? void 0 : data.containerWithDraw) || {};
  const maxShares = containerWithDraw.maxShares,
    soldShares = containerWithDraw.soldShares;
  const availableShares = maxShares - soldShares;
  return availableShares;
};
const marketplaceMultipleShares = onInteraction => _ref2 => {
  let payment = _ref2.payment;
  return async next => {
    const payableItems = payment.getPayableItems();
    const marketplaceWagerIndex = payableItems.findIndex(payable => payable.activatedDrawId);
    const marketplaceWager = payableItems[marketplaceWagerIndex];
    const activatedDrawId = marketplaceWager.activatedDrawId;
    const containerId = marketplaceWager.containerId;
    const groupId = marketplaceWager.groupId;
    const count = marketplaceWager.count;
    const availableShares = await getAvailableShares({
      activatedDrawId,
      containerId,
      groupId
    });
    if (availableShares === 0 || availableShares >= count) {
      return next();
    }
    const suffix = availableShares > 1 ? 'andelar' : 'andel';
    const numberOfSharesText = "".concat(availableShares, " ").concat(suffix);
    const title = "Det finns bara ".concat(numberOfSharesText, " kvar");
    const messages = ['Tyvärr finns inte det antalet andelar du önskar köpa kvar till försäljning.', "Vill du k\xF6pa ".concat(numberOfSharesText, "?"), 'Nej, avbryt', "Ja, k\xF6p ".concat(numberOfSharesText)];
    const data = {
      availableShares
    };
    try {
      logger.info("Showing dialog, not enough shares left. Available shares: ".concat(availableShares, ", selected count: ").concat(count));
      await onInteraction(new InteractionContext(InteractionContext.Severity.INFO, InteractionContext.Code.NOT_ENOUGH_SHARES, data, title, messages));
      marketplaceWager.setCount(availableShares);
      marketplaceWager.setPrice(marketplaceWager.fractionPrice * availableShares);
    } catch (err) {
      logger.debug(err === null || err === void 0 ? void 0 : err.message, err);
      const mwError = new MiddlewarePaymentError({
        clientCode: MiddlewarePaymentError.ErrorCodes.PAYMENT_ABORTED_MP_SHARES
      });
      next(mwError);
    }
    next();
  };
};
setGlobal('svs.components.payment.middleware.marketplaceMultipleShares', marketplaceMultipleShares);

 })(window);